import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/common/PageHero";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { CRITERIA, SECTORS, IMAGES } from "@/lib/content";
import { useSeo } from "@/lib/seo";

export default function Acquisitions() {
  useSeo({
    title: "Nos Critères d'Acquisition — Rachat & reprise de PME | Losta Group",
    description:
      "Les critères d'acquisition de Losta Group : savoir-faire, clientèle, équipe, potentiel, implantation. Rachat et reprise d'entreprises de la communication visuelle en France et en Suisse.",
    path: "/acquisitions",
  });
  return (
    <>
      <PageHero
        eyebrow="Nos critères d'acquisition"
        lines={["Les entreprises", "que nous recherchons."]}
        sub="Nous recherchons des savoir-faire techniques, des équipes compétentes et un potentiel de développement, en France et en Suisse."
        image={IMAGES.welding}
      />

      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {CRITERIA.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.05}>
                <div className="h-full rounded-2xl border border-white/10 card-lux p-6">
                  <span className="font-serif text-4xl text-gold/80">{c.n}</span>
                  <h3 className="mt-4 font-serif text-2xl text-white">{c.title}</h3>
                  <p className="mt-2 text-sm text-[var(--txt-2)] font-light">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-[#0B0D13] border-y border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <SectionHeading eyebrow="Par secteur" lines={["Les métiers", "que nous acquérons."]} className="mb-12" />
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SECTORS.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.05}>
                <Link to={`/acquisitions/${s.slug}`} className="group flex items-center justify-between rounded-2xl border border-white/10 card-lux p-6" data-testid={`acq-link-${s.slug}`}>
                  <div>
                    <span className="font-mono text-xs text-gold">{s.n}</span>
                    <h3 className="mt-1 font-serif text-2xl text-white group-hover:text-gold transition-colors">{s.title}</h3>
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-white/40 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
